let authToken: string | null = null;
let authGeneration = 0;

export const setAuthToken = (token: string | null) => {
    authGeneration += 1;
    authToken = token;
};

export const getAuthToken = (): string | null => authToken;

export const getAuthGeneration = (): number => authGeneration;

export const clearAuthToken = () => {
    authGeneration += 1;
    authToken = null;

    try {
        localStorage.removeItem('selectedOrganization');
    } catch (e) {
        console.error('Failed to remove organization from localStorage:', e);
    }
};

export const getSelectedOrganization = () => {
    try {
        const org = localStorage.getItem('selectedOrganization');
        return org ? JSON.parse(org) : null;
    } catch (e) {
        console.error('Failed to read organization from localStorage:', e);
        return null;
    }
};

export const setSelectedOrganization = (organization: any) => {
    try {
        localStorage.setItem('selectedOrganization', JSON.stringify(organization));
    } catch (e) {
        console.error('Failed to save organization to localStorage:', e);
    }
};
